(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './proptypes'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./proptypes'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.proptypes);
    global.index = mod.exports;
  }
})(this, function (exports, _proptypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.keys(_proptypes).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function () {
        return _proptypes[key];
      }
    });
  });
  var calculateRgba = exports.calculateRgba = function calculateRgba(color, opacity) {
    if (color[0] === '#') {
      color = color.slice(1);
    }

    if (color.length === 3) {
      var res = '';
      color.split('').forEach(function (c) {
        res += c;
        res += c;
      });
      color = res;
    }

    var rgbValues = color.match(/.{2}/g).map(function (hex) {
      return parseInt(hex, 16);
    }).join(', ');
    return 'rgba(' + rgbValues + ', ' + opacity + ')';
  };
});


//////////////////
// WEBPACK FOOTER
// ./~/react-spinners/helpers/index.js
// module id = 20
// module chunks = 0